import store from '@/store';
import Segment from '@/Segment';
import { CHAT_POPUP_SEEN_KEY } from '@/constants/chat';
import Chatbot from './Chatbot.vue';
import ChatPopup from './ChatPopup.vue';

// showIntro shows the one-time explainer popup first, which then forwards to the chatbot.
// Support entry points skip it — the user already asked for help.
export default function openAssistant({ initiator, initialMessage = null, showIntro = false, utmCampaign = null }) {
  Segment.trackUserInteraction('AIChatbot_Opened', {
    source: initiator,
    ...(utmCampaign ? { utm_campaign: String(utmCampaign) } : {}),
  });
  if (showIntro && !localStorage.getItem(CHAT_POPUP_SEEN_KEY)) {
    store.dispatch('modalRootStore/openModal', {
      component: ChatPopup,
      props: { initialMessage, initiator },
    });
    return;
  }
  store.dispatch('modalRootStore/openModal', {
    component: Chatbot,
    props: { initialMessage, initiator },
    popupAlignment: 'menu',
  });
}
